import React, { useState, useEffect } from "react"
import { createPromo, updatePromo, deletePromo } from '../../../lib/actions'
import { fetchPromos } from '../../../lib/queries'
import PromoModal from "./PromoModal"
import moment from "moment"
import AdminTable from '../../../components/AdminTable'
import PromoCSVUploadModal from "./PromoCSVUploadModal"
import ConfirmationModal from "../../../components/ConfirmationModal"

const CREATE_ACTION = "create"
const EDIT_ACTION = "update"
const DELETE_ACTION = "delete"

function PromosTable() {
    const [promos, setPromos] = useState([])
    const [searchTerm, setSearchTerm] = useState("")
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(true)

    const loadPromos = async () => {
        try {
            const data = await fetchPromos()
            setPromos(data)
        } catch (error) {
            console.error("Error loading airports:", error)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadPromos()
    }, [])


    const filteredPromos = promos.filter((promo) =>
        promo.code.toLowerCase().includes(searchTerm.toLowerCase())
    )


    const toggleModal = (modalName) => {
        if (modalName === showModal) {
            setShowModal(false)
        } else {
            setShowModal(modalName)
        }
    }


    const handleSubmit = async (data, action) => {
        try {
            if (action === EDIT_ACTION) {
                await updatePromo(data.code, data)
            } else if (action === CREATE_ACTION) {
                await createPromo(data)
            } else if (action === DELETE_ACTION) {
                await deletePromo(data.id)
            }
            await loadPromos()
            setShowModal(false)
        } catch (error) {
            console.error('Error saving promo:', error)
        }
    }

    if (loading) {
        return <div>Loading...</div>
    }

    return (
        <section>
            <div className="row">
                <div className="col-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter promo code"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                {showModal === "createPromo" && <PromoModal
                    isOpen={showModal === "createPromo"}
                    onClose={() => toggleModal("createPromo")}
                    mode={CREATE_ACTION}
                    onSubmit={(data) => handleSubmit(data, CREATE_ACTION)}
                />}
                <div className="col-md-4 ms-auto text-end">
                    <button className="btn btn-primary" onClick={() => toggleModal("createPromo")}>
                        Add Promo
                    </button>&nbsp;&nbsp;
                    <button className="btn btn-success" onClick={() => toggleModal("PromoCSVUploadModal")}>
                        Upload CSV
                    </button>
                </div>
            </div>

            <AdminTable>
                <thead className="thead-light">
                    <tr>
                        <th>#</th>
                        <th>Code</th>
                        <th>Expiration Date</th>
                        <th>Status</th>
                        <th>Redeem Limit</th>
                        <th>Redeemed</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredPromos.map((promo, index) => (
                        <tr key={promo.id}>
                            <td>{index + 1}</td>
                            <td>{promo.code}</td>
                            <td className={moment().isAfter(moment(promo.expirationDate).endOf('day')) ? "text-danger" : moment().isSame(moment(promo.expirationDate), 'day') ? "text-warning" : ""}>
                                {moment(promo.expirationDate).format("YYYY-MM-DD")}
                            </td>
                            <td>
                                <span className={promo.isActive ? "text-success" : "text-danger"}>
                                    {promo.isActive ? "Active" : "Inactive"}
                                </span>
                            </td>
                            <td>
                                <span>
                                    {promo.redeemLimit ? promo.redeemLimit : "0"}
                                </span>
                            </td>
                            <td>
                                <span>
                                    {promo.redeemed ? promo.redeemed : "0"}
                                </span>
                            </td>
                            <td>
                                {showModal === "editPromo" + index && <PromoModal
                                    isOpen={showModal === "editPromo" + index}
                                    onClose={() => toggleModal("editPromo" + index)}
                                    mode={EDIT_ACTION}
                                    promoData={promo}
                                    onSubmit={(data) => handleSubmit(data, EDIT_ACTION)}
                                />}
                                <span className="material-symbols-outlined text-primary-color" onClick={() => toggleModal("editPromo" + index)} style={{ cursor: "pointer" }}>
                                    edit
                                </span>
                                {showModal === "deletePromo" + index && <ConfirmationModal isOpen={showModal === "deletePromo" + index} onClose={() => toggleModal("deletePromo" + index)} actionBtnText="Delete" onAction={() => handleSubmit(promo, DELETE_ACTION)} title="Delete Promo" body="Are you sure you want to delete this promo?" />}
                                <span className="material-symbols-outlined text-red-color ms-2" onClick={() => toggleModal("deletePromo" + index)} style={{ cursor: "pointer" }}>
                                    delete
                                </span>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </AdminTable>

            {showModal === "PromoCSVUploadModal" &&
                <PromoCSVUploadModal
                    isOpen={showModal === "PromoCSVUploadModal"}
                    onClose={() => toggleModal("PromoCSVUploadModal")}
                    existingPromos={promos}
                    onComplete={() => {
                        toggleModal("PromoCSVUploadModal")
                    }}
                />}
        </section>
    )
}

export default PromosTable
